function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {};

    this.images = {'camouflage-matt': 'url("//www.zttlprint.com/cdn/shop/files/Camouflage_120x.jpg?v=10541947919241599979")','endurance-matt': 'url("//www.zttlprint.com/cdn/shop/files/Endnurance_120x.jpg?v=10992854588857358238")','erlkonig-glanzend': 'url("//www.zttlprint.com/cdn/shop/files/Erlkoenig_120x.jpg?v=4969700218701111851")','flow-glanzend': 'url("//www.zttlprint.com/cdn/shop/files/Flow_120x.jpg?v=10693104817976100596")','gear-glanzend': 'url("//www.zttlprint.com/cdn/shop/files/Gear_120x.jpg?v=13378613143047617945")','gelsenkirchen-glanzend': 'url("//www.zttlprint.com/cdn/shop/files/BH_Gelsenkirchen_120x.jpg?v=6688924972299657608")','pop-matt': 'url("//www.zttlprint.com/cdn/shop/files/Pop_120x.jpg?v=16516547330573480004")','racing-glanzend': 'url("//www.zttlprint.com/cdn/shop/files/Racing_120x.jpg?v=15139792685276641890")','royal-matt': 'url("//www.zttlprint.com/cdn/shop/files/Royal_120x.jpg?v=15921905080089197559")','schildkrote-matt': 'url("//www.zttlprint.com/cdn/shop/files/Schildkroete_120x.jpg?v=5716176351292113622")','speed-glanzend': 'url("//www.zttlprint.com/cdn/shop/files/Speed_120x.jpg?v=873297809707675732")','stripes-glanzend': 'url("//www.zttlprint.com/cdn/shop/files/Stripes_120x.jpg?v=11036191730835391292")','wave-glanzend': 'url("//www.zttlprint.com/cdn/shop/files/Wave_120x.jpg?v=594143953378602641")','individualisierung': 'url("//www.zttlprint.com/cdn/shop/files/Individualisierung_120x.jpg?v=13170271658822697414")',};

    this.triggers = ['color','colour','couleur','farbe','cor','motiv',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
